export default {
  "tickPath": "_tickPath_1ee6o_1",
  "tickVisible": "_tickVisible_1ee6o_14",
  "tickHidden": "_tickHidden_1ee6o_19"
};import "ni:sha-256;tkP_VaaOTqJhTSyfZXSCdrmqI7v8M7XpvT7h2vRifDs";